import React from "react";
import { isMobile } from "react-device-detect";
import { useQuery } from "@apollo/client";
import DesktopHeader from "../../Header/DesktopHeader";
import MobileHeader from "../../Header/MobileHeader";
import DeskFooter from "../DeskFooter";
import MobileFooter from "../MobileFooter";
import SeoManager from "../../seoManager";

import { TERMS_AND_CONDITIONS } from "../../../gqlOperations/queries";

export default function TermsConditions() {
  // document.title = "Terms and Conditions | KheloMore";
  const { loading, error, data } = useQuery(TERMS_AND_CONDITIONS);
  const htmlData = data?.termsAndConditions?.data.map(
    (details) => details?.attributes?.Value,
  );
  return (
    <>
      <SeoManager
        pageTitle="Terms and Conditions | KheloMore"
        description="Read KheloMore’s Terms & Conditions to understand the rules, guidelines, booking policies, user responsibilities, payments, cancellations, and platform usage terms for venues, coaching, events, and sports activities across India."
      />
      {isMobile ? (
        <div>
          <MobileHeader />
          <div>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </div>
          {/* <div style={{ width: "90%", margin: "20px 14px" }}>
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "700",
                marginTop: "-32px",
                textTransform: "uppercase",
              }}
            >
              WhatsApp policy
            </h2>
            <p>&nbsp;</p>
            <p
              style={{
                fontSize: "14px",
                paddingBottom: "32px",
                lineHeight: "1.5",
              }}
            >
              We use WhatsApp to send booking confirmations, OTPs, and updates
              to users who have opted in.
            </p>
          </div> */}
          {/* <MobileFooter />     */}
        </div>
      ) : (
        <div>
          <DesktopHeader />
          <div>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </div>
          {/* <div style={{ width: "55%", margin: "0 auto" }}>
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "700",
                marginTop: "-32px",
                textTransform: "uppercase",
              }}
            >
              WhatsApp policy
            </h2>
            <p>&nbsp;</p>
            <p style={{ fontSize: "14px", paddingBottom: "64px" }}>
              We use WhatsApp to send booking confirmations, OTPs, and updates
              to users who have opted in.
            </p>
          </div> */}
          <DeskFooter />
        </div>
      )}
    </>
  );
}
